import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { ApplicationInsightsService } from './../application-insights/application-insights.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private _applicationInsightsService: ApplicationInsightsService) {}
  handleError(error: Error | HttpErrorResponse): void {
    console.error(error);
    this._applicationInsightsService.logError(error);
  }
}
